define.alias("shared/components/shared/ui/navigation-arrows", "calendar/components/shared/ui/navigation-arrows");